import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import course103 from "../data/courses/course103";

import MCQQuestion from "../components/MCQQuestion";

import "../styles/Quiz.css";

const QuizSectionA = () => {
  const navigate = useNavigate();

  const questions = course103.assessment.mcq;

  const [currentQuestion, setCurrentQuestion] = useState(0);

  const [answers, setAnswers] = useState<Record<number, string>>({});

  const question = questions[currentQuestion];

  const handleSelect = (answer: string) => {
    const updated = {
      ...answers,
      [question.id]: answer,
    };

    setAnswers(updated);

    localStorage.setItem("course103_mcq_answers", JSON.stringify(updated));
  };

  const nextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      navigate("/quiz/section-b");
    }
  };

  return (
    <div className="quiz-page">
      <h2 className="section-heads">COURSE 102 – FINAL ASSESSMENT</h2>
      <h3 className="quiz-section-title">{question.title}</h3>{" "}
      <MCQQuestion
        questionNumber={currentQuestion + 1}
        totalQuestions={questions.length}
        question={question.question}
        options={question.options}
        selectedAnswer={answers[question.id] || ""}
        onSelect={handleSelect}
      />
      <button className="quiz-btn" onClick={nextQuestion}>
        {currentQuestion === questions.length - 1
          ? "Proceed To Section B"
          : "Next"}
      </button>
    </div>
  );
};

export default QuizSectionA;
